import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/appointment";

export const pagingAppointment = (searchAppointment) =>
  axios.post(API_PATH + "/search-by-page-confirmed", searchAppointment);

export const getNearestApp = (dto) =>
  axios.post(API_PATH + "/get-nearest-appointment", dto);

export const callPatientAppointment = (dto) =>
  axios.post(API_PATH + "/call-patient-appointment", dto);

export const receiveCustomersByAppointment = (searchAppointment) =>
  axios.post(API_PATH + "/receive-customers-by-appointment", searchAppointment);
export const getAppointmentById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);
export const saveOrUpdateAppointmentByStaff = (appointment) =>
  axios.post(API_PATH + "/save-appointment-by-staff", appointment);
export const cancelAppointment = (obj) =>
  axios.post(API_PATH + "/cancel-appointment", obj);

// api cập nhật tt appointment
export const updateAppointmentStatus = (appointment) =>
  axios.post(API_PATH + "/update-appointment-status", appointment);
export const updateAppointmentStatusAndCheckIn = (appointment) =>
  axios.post(API_PATH + "/update-appointment-status-and-checkin", appointment);

export const countingByStatus = (appointment) =>
  axios.post(API_PATH + "/counting-by-status", appointment);

export const countingByHourly = (appointment) =>
  axios.post(API_PATH + "/counting-by-hourly", appointment);

export const countingByDay = (appointment) =>
  axios.post(API_PATH + "/counting-by-day", appointment);

export const countingByDayConfirm = (appointment) =>
  axios.post(API_PATH + "/counting-by-day-confirmed", appointment);

export const getServicesByAppointmentCheckIn = (payload) =>
  axios.post(API_PATH + "/services-by-appointment-check-in", payload);

export const getBySriId = (sriId) =>
  axios.get(API_PATH + `/get-by-sri-id/${sriId}`);

export const exportExcelAppointmentList = (obj) => {
  let url = API_PATH + "/export-excel-appointment-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const pagingAsyncAppointment = (searchAppointment) =>
  axios.post(API_PATH + "/search-by-page-sync", searchAppointment);

export const checkOutAppointmentAuto = (searchAppointment) =>
  axios.post(API_PATH + "/check-out-appointment-auto", searchAppointment);

export const deleteAppointment = (id) =>
  axios.delete(API_PATH + `/void-appointment/${id}`);